// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2LkIO","name":"ConsentHeader_name__3uMU4","birthday":"ConsentHeader_birthday__2kkc2","skeleton":"ConsentHeader_skeleton__6FZCw"};